import { exportFile } from 'quasar';
import * as XLSX from 'xlsx';

export default class FileExporter {
    constructor({ headers = [] }) {
        // predefined headers for export
        this.headers = headers;
    }

    exportCSV({ filename = 'report', rows = [] }) {
        const headers = this.headers.join(',') + '\n';
        // enclose all strings in quotes in case they contain commas
        const formattedRows = rows.map(row => {
            return row.map(value => {
                if (typeof value === 'string') {
                    return `"${value}"`;
                }
                return value;
            });
        });
        const rowsData = formattedRows.join(', \n');
        exportFile(`${filename}.csv`, headers + rowsData, 'text/csv');
    }

    exportXLS({ filename = 'report', sheetName = 'Report', rows = [] }) {
        // make a copy
        const fileData = [...rows];

        // prepend headers to rows in an array of array (aoa)
        fileData.unshift(this.headers);

        /* make the worksheet */
        var ws = XLSX.utils.aoa_to_sheet(fileData);

        /* add to workbook */
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, sheetName);

        /* generate an XLSX file */
        XLSX.writeFile(wb, `${filename}.xlsx`);
    }
}
